import { create } from "zustand";
import { persist } from "zustand/middleware";
import { v4 as uuidv4 } from "uuid";
import { AzureCommunicationTokenCredential } from "@azure/communication-common";

type User = {
	username: string;
	id: string;
};

type SelfACSUser = {
	id: string;
	token: string;
	credential: AzureCommunicationTokenCredential;
};

export type SelfUser = Partial<User & { communicationId: string }>;

type UserStore = {
	user: User;
	acs: Partial<SelfACSUser>;
	getUser: () => SelfUser;
	setUser: (user: Partial<User>) => void;
	setUsername: (username: string) => void;
	setACSTokenIdentity: (acsUser: Omit<SelfACSUser, "credential">) => void;
};

const useUserStore = create(
	persist<UserStore>(
		(set, get) => ({
			user: {
				username: "",
				id: uuidv4(),
			},
			acs: {
				identity: undefined,
				token: undefined,
				credential: undefined,
			},
			getUser: () => {
				const { user, acs } = get();

				return { ...user, communicationId: acs.id };
			},
			setUsername: (username) =>
				set(({ user }) => ({ user: { ...user, username } })),
			setUser: (user) =>
				set(({ user: oldUser }) => ({ user: { ...oldUser, ...user } })),
			setACSTokenIdentity: ({ token, id }) => {
				try {
					const credential = new AzureCommunicationTokenCredential(token);
					set(() => ({
						acs: {
							id,
							token,
							credential,
						},
					}));
					console.log("✅ successfully created ACS credential");
				} catch (error) {
					console.error("❌ error creating ACS credential", error);
				}
			},
		}),
		{ name: "user" },
	),
);

export default useUserStore;
